import zone from './zone';
import overlay from './overlay';
import ribbon from './ribbon';

export default { overlay, zone, ribbon };
